// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__-zlPQ","message":"CookieConsent_message__1SlGV","cookieLink":"CookieConsent_cookieLink__1GOkW","continueBtn":"CookieConsent_continueBtn__3WhRF"};